import Vue from 'vue'
import Vuex from 'vuex'

import metadata from './modules/metadata'
import references from './modules/references'
import duplicates from './modules/duplicates'
import tableFields from './modules/tableFields'

Vue.use(Vuex)

export default new Vuex.Store({
	modules: {
		metadata,
		references,
		duplicates,
		tableFields
	},
	actions: {
		resetStore({ commit }) {
			commit('metadata/reset');
			commit('references/reset');
			commit('duplicates/reset');
			commit('tableFields/reset');
		}
	}
})